import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  ConfigProvider,
  Steps,
  Col,
  Row,
  Layout,
  Typography,
  Select,
  Radio,
  Divider,
  // Space,
} from "antd";
import { WhatsAppOutlined, SafetyCertificateOutlined } from "@ant-design/icons";

import PropTypes from "prop-types";
//components
import "./user.css";
import SimpleReactValidator from "simple-react-validator";
import { billbookSource } from "./billing-details";
import TinyColor from "@ctrl/tinycolor";
import { isEmpty } from "lodash";
import { emailIsValid } from "../Auth/validations";
import { useDispatch, useSelector } from "react-redux";
import { loadRecordsMetaData } from "../../store/organisation/actions";
import api from "../../helpers";
import { useHistory } from "react-router";
import useMedia from "use-media-antd-query";

const UserDetails = (props) => {
  const getHoverColors = (colors) =>
    colors.map((color) => new TinyColor(color).lighten(5).toString());
  const getActiveColors = (colors) =>
    colors.map((color) => new TinyColor(color).darken(5).toString());

  const colors1 = ["#6253E1", "#04BEFE"];

  const { Header, Content, Footer } = Layout;

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const media = useMedia();

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  //State values for initial setup
  const [current, setCurrent] = useState(0);
  // const [mouseHover, setMouseHover] = useState(false);
  const [businessData, setBusinessData] = useState({
    businessName: "",
    gstIn: "",
    mobileNo: "",
    email: "",
    address: "",
  });

  //api loader
  // const userResponse = localStorage.getItem("user");
  const userMobileLocation = !isEmpty(props.location.state)
    ? props.location.state
    : "";
  console.log(userMobileLocation, "userMobileLocation");
  useEffect(() => {
    dispatch(loadRecordsMetaData());

    setBusinessData({
      mobileNo: !isEmpty(userMobileLocation) ? userMobileLocation.mobileNo : "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //state reducer
  const { recordsMetaData = {} } = useSelector((state) => state.Organisation);

  const planLastArray =
    !isEmpty(recordsMetaData) && recordsMetaData.planOptions
      ? recordsMetaData.planOptions[recordsMetaData.planOptions.length - 1]
      : "";
  const sizeLastArray =
    !isEmpty(recordsMetaData) && recordsMetaData.sizeOptions
      ? recordsMetaData.sizeOptions[recordsMetaData.sizeOptions.length - 1]
      : "";
  const billbookLastArray = billbookSource
    ? billbookSource[billbookSource.length - 1]
    : "";

  // single state values

  const [isGst, setIsGst] = useState("");

  const [organizationCategory, setOrganizationCategory] = useState([]);
  const [country, setCountry] = useState([]);
  const [stateDetails, setStateDetails] = useState([]);
  const [gstType, setGstType] = useState([]);

  //state vaues for billing details
  const [billingType, setBillingType] = useState("");
  const [businessSizes, setBusinessSizes] = useState("");

  //state vaues for billing Source
  const [billingSourceData, setBillingSourceData] = useState("");
  const [language, setLanguage] = useState([]);
  const [businessSectionOne, setBusinessSectionOne] = useState(false);
  const [businessSectionTwo, setBusinessSectionTwo] = useState(false);
  const [error, setError] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      // mobileNumber: /^[0-9]*$/, // Only numeric characters allowed
      mobileNo: /^[0-9]\d*\.?\d*$/,
      email: /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setBusinessData({
          ...businessData,
          [name]: value,
        });
      }
    } else {
      setBusinessData({
        ...businessData,
        [name]: value,
      });
    }
  };

  const [email, setEmail] = useState("");

  //Email validation changes
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
    }
  };

  // const statusOnChange = (e) => {
  //   console.log(e);
  //   setCurrent(e);
  // };

  console.log(error, "error");
  const onFinish = () => {
    if (
      !isEmpty(organizationCategory) &&
      !isEmpty(businessData.businessName) &&
      !businessSectionOne &&
      !businessSectionTwo
    ) {
      setCurrent(1);
      setBusinessSectionOne(true);
    } else if (
      businessSectionOne &&
      !businessSectionTwo &&
      !isEmpty(billingType) &&
      !isEmpty(businessSizes)
    ) {
      setCurrent(2);
      setBusinessSectionTwo(true);
    } else if (
      businessSectionTwo &&
      isGst === "false" &&
      simpleValidator.current.allValid()
    ) {
      // setCurrent(2);
      console.log("section3", "section3");
      const businessUserDetails = {
        organizationName: businessData.businessName,
        organizationEmail: email,
        userId: !isEmpty(userMobileLocation) && userMobileLocation._id,

        organizationPhone: businessData.mobileNo,
        organizationCategory: organizationCategory,
        countryId: country,
        stateId: stateDetails,
        isGst: isGst === "true" ? true : false,
        address: businessData.address,
        planId: billingType,
        sizeId: businessSizes,
        wheredofindMbook: billingSourceData,
        communicateLanguageId: language,
      };

      const payloadObj = Object.keys(businessUserDetails).forEach(
        (k) =>
          (businessUserDetails[k] === "" ||
            businessUserDetails[k] === undefined) &&
          delete businessUserDetails[k]
      );
      console.log(payloadObj, "payloadObj");
      setRegisterLoading(true);
      setTimeout(() => {
        setRegisterLoading(false);
      }, 2000);
      api
        .post("/org/createorganization", businessUserDetails)
        .then((res) => {
          history.push({ pathname: "/dashboard", state: res.data });
          localStorage.setItem("userDetails", JSON.stringify(res.data));
          localStorage.setItem("authData", JSON.stringify(res.data));
          console.log(res.data, "response in organisationss");
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error;
          setError(
            errorMsg || "There is an issue while adding the organizations"
          );
          Promise.reject(error);
        });
      console.log(businessUserDetails, "stage 3 completed");
    } else if (businessSectionTwo && simpleValidator.current.allValid()) {
      // setCurrent(2);
      console.log("section3", "section3");
      const businessUserDetails = {
        organizationName: businessData.businessName,
        organizationEmail: email,
        userId: !isEmpty(userMobileLocation) && userMobileLocation._id,
        organizationPhone: businessData.mobileNo,
        organizationCategory: organizationCategory,
        countryId: country,
        stateId: stateDetails,
        isGst: isGst === "true" ? true : false,
        gstType: isGst === "true" ? gstType : "",
        gstNumber: isGst === "true" ? businessData.gstIn : "",
        address: businessData.address,
        planId: billingType,
        sizeId: businessSizes,
        wheredofindMbook: billingSourceData,
        communicateLanguageId: language,
      };
      const payloadObj = Object.keys(businessUserDetails).forEach(
        (k) =>
          (businessUserDetails[k] === "" ||
            businessUserDetails[k] === undefined) &&
          delete businessUserDetails[k]
      );
      console.log(payloadObj, "payloadObj");
      setRegisterLoading(true);
      setTimeout(() => {
        setRegisterLoading(false);
      }, 2000);
      api
        .post("/org/createorganization", businessUserDetails)
        .then((res) => {
          // history.push("/dashboard");
          // localStorage.setItem("userDetails", res.data);
          history.push({ pathname: "/dashboard", state: res.data });
          localStorage.setItem("userDetails", JSON.stringify(res.data));
          localStorage.setItem("authData", JSON.stringify(res.data));
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error;
          setError(
            errorMsg || "There is an issue while adding the organizations"
          );
          Promise.reject(error);
        });
      console.log(businessUserDetails, "stage 3 completed");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      // setValidation(true)
    }
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <React.Fragment>
      <div className="register-main overflow-x-hidden overflow-y-hidden">
        <div className="p-7 bg-[#ffffff]">
          <Layout className="user-details">
            <Header className="text-center user-details-header">
              <Row className="mt-8" justify={"center"}>
                <Col span={12}>
                  <Row>
                    <Steps
                      current={current}
                      // onChange={statusOnChange}
                      responsive={true}
                      type=""
                      items={[
                        {
                          title: "",
                        },
                        {
                          title: "",
                        },
                        {
                          title: "",
                        },
                      ]}
                    />
                  </Row>
                </Col>
              </Row>
            </Header>
            <Content>
              <Row className="mt-[30px]">
                <Col span={24}>
                  <Form
                    form={form}
                    name="register"
                    // onFinish={onFinish}
                    className="register-main-form"
                    scrollToFirstError
                  >
                    <Typography className="w-[80%] register-fonts mt-4 mb-2 text-[red] text-start text-[12px]">
                      {!isEmpty(error) && error ? error : ""}
                    </Typography>
                    {/* Billing Requirements */}
                    {current === 1 ? (
                      <Row>
                        <Col
                          span={13}
                          // onMouseEnter={() => setMouseHover(true)}
                          // onMouseLeave={() => setMouseHover(false)}
                        >
                          <Row
                            className={
                              windowDimensions.height >= 500 &&
                              windowDimensions.height <= 600
                                ? "user-2-invoices-tab-device-main ml-4"
                                : windowDimensions.height >= 600 &&
                                  windowDimensions.height <= 650
                                ? "user-2-invoices-large-tab-device-main ml-4"
                                : windowDimensions.height >= 700 &&
                                  windowDimensions.height <= 800
                                ? "user-2-invoices-main-large-device ml-4"
                                : windowDimensions.height >= 800 &&
                                  windowDimensions.height <= 900
                                ? "user-2-invoices-main-extra-large-device ml-6"
                                : windowDimensions.height >= 900 &&
                                  windowDimensions.height <= 960
                                ? "user-2-invoices-main-extra-extra-large-device ml-6"
                                : windowDimensions.height >= 960 &&
                                  windowDimensions.height <= 1000
                                ? "user-2-invoices-main-extra-extra-large-based-device ml-6"
                                : windowDimensions.height >= 1000
                                ? "user-2-invoices-main-infinite-extra-large-device ml-6"
                                : "user-2-invoices-main ml-4"
                            }
                          >
                            <Col span={24} className="px-4 mb-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Select your billing requirement?{" "}
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Radio.Group
                                className="w-[100%] billing-types mb-2"
                                onChange={(e) => setBillingType(e.target.value)}
                                value={billingType}
                              >
                                {recordsMetaData &&
                                  recordsMetaData.planOptions.map(
                                    (data, index) => {
                                      return (
                                        <div key={index}>
                                          <div
                                            className="flex justify-between"
                                            style={{
                                              // borderBottom:
                                              //   index === 2
                                              //     ? ""
                                              //     : "1px solid lightgray",
                                              //   borderBottomWidth: "105%",
                                              //   marginLeft: "-10px",
                                              padding: "7px",
                                            }}
                                          >
                                            <div className="text-start">
                                              <Typography
                                                style={{
                                                  fontFamily: "Poppins",
                                                }}
                                                className="font-semibold"
                                              >
                                                {data.label}
                                              </Typography>
                                              <Typography
                                                style={{
                                                  fontFamily: "Poppins",
                                                }}
                                                className="text-[gray]"
                                              >
                                                <span className="font-medium">
                                                  {" "}
                                                  Devices:
                                                </span>{" "}
                                                {data.devices}
                                              </Typography>
                                              <Typography
                                                style={{
                                                  fontFamily: "Poppins",
                                                }}
                                                className="text-[gray]"
                                              >
                                                <span className="font-medium">
                                                  {" "}
                                                  Number of Users:{" "}
                                                </span>{" "}
                                                {data.numberOfUsers}
                                              </Typography>
                                              {data.description ? (
                                                <Typography
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                  className="text-[gray]"
                                                >
                                                  <span className="font-medium">
                                                    Extras:
                                                  </span>{" "}
                                                  {data.description}
                                                </Typography>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            <Radio
                                              value={data.value}
                                              disabled={
                                                index !== 0 ? true : false
                                              }
                                            ></Radio>
                                          </div>
                                          {planLastArray.value ===
                                          data.value ? (
                                            ""
                                          ) : (
                                            <Divider
                                              style={{
                                                width: "104.5%",
                                                marginLeft: "-8px",
                                                borderWidth: "0.2px",
                                                marginTop: "1px",
                                                marginBottom: "2px",
                                              }}
                                            />
                                          )}
                                        </div>
                                      );
                                    }
                                  )}
                              </Radio.Group>
                              <span className="mt-[5px] text-start text-[12px] text-[red]">
                                {simpleValidator.current.message(
                                  "billingType",
                                  billingType,
                                  "required"
                                )}
                              </span>
                            </Col>
                            <Col span={24} className="px-4 mb-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Size of your business?{" "}
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Radio.Group
                                className="w-[100%] billing-types mb-2"
                                onChange={(e) =>
                                  setBusinessSizes(e.target.value)
                                }
                                value={businessSizes}
                              >
                                {recordsMetaData &&
                                  recordsMetaData.sizeOptions.map(
                                    (data, index) => {
                                      return (
                                        <div key={index}>
                                          <div
                                            className="flex justify-between"
                                            key={index}
                                            style={{
                                              // borderBottom:
                                              //   index === 2
                                              //     ? ""
                                              //     : "1px solid lightgray",
                                              //   marginLeft: "-10px",
                                              padding: "7px",
                                            }}
                                          >
                                            <Typography>
                                              {data.label}
                                            </Typography>
                                            <Radio value={data.value}></Radio>
                                          </div>

                                          {sizeLastArray.value ===
                                          data.value ? (
                                            ""
                                          ) : (
                                            <Divider
                                              style={{
                                                width: "104.5%",
                                                marginLeft: "-8px",
                                                borderWidth: "0.2px",
                                                marginTop: "1px",
                                                marginBottom: "2px",
                                              }}
                                            />
                                          )}
                                        </div>
                                      );
                                    }
                                  )}
                              </Radio.Group>
                              <span className="mt-[5px] text-start text-[12px] text-[red]">
                                {simpleValidator.current.message(
                                  "businessSizes",
                                  businessSizes,
                                  "required"
                                )}
                              </span>
                            </Col>

                            <Col span={24} className="mt-2 px-4 mb-[60px]">
                              <div className="w-[100%]">
                                <Typography
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="text-center font-semibold"
                                >
                                  <WhatsAppOutlined className="text-[green]" />{" "}
                                  Receive account updates and reminders on
                                  WhatsApp
                                </Typography>
                              </div>
                              <div className="w-[100%] text-center mt-3 ">
                                <Typography
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="instructions font-semibold"
                                >
                                  <SafetyCertificateOutlined className="text-[#4096ff] mx-1" />{" "}
                                  100% secure
                                </Typography>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ) : current === 2 ? (
                      <Row
                        className={
                          media === "md" || media === "sm" || media === "xs"
                            ? "ml-6"
                            : media === "xl"
                            ? "ml-12"
                            : media === "xxl"
                            ? "ml-[100px]"
                            : "ml-6"
                        }
                      >
                        <Col
                          span={13}
                          // onMouseEnter={() => setMouseHover(true)}
                          // onMouseLeave={() => setMouseHover(false)}
                        >
                          <Row>
                            <Col span={24} className="px-4 mb-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                How did you find out about myBillBook?{" "}
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Radio.Group
                                className="w-[100%] billing-types mb-2"
                                onChange={(e) =>
                                  setBillingSourceData(e.target.value)
                                }
                                value={billingSourceData}
                              >
                                {billbookSource.map((data, index) => {
                                  return (
                                    <div key={index}>
                                      <div
                                        className="flex justify-between"
                                        style={{
                                          //   borderBottomWidth: "105%",
                                          //   marginLeft: "-10px",
                                          padding: "7px",
                                        }}
                                      >
                                        <div className="text-start">
                                          <Typography
                                            style={{
                                              fontFamily: "Poppins",
                                            }}
                                            className="font-medium"
                                          >
                                            {data.label}
                                          </Typography>
                                        </div>
                                        <Radio value={data.value}></Radio>
                                      </div>
                                      {billbookLastArray.value ===
                                      data.value ? (
                                        ""
                                      ) : (
                                        <Divider
                                          style={{
                                            width: "103.4%",
                                            marginLeft: "-8px",
                                            marginTop: "1px",
                                            marginBottom: "2px",
                                          }}
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                              </Radio.Group>
                              <span className="mt-[5px] text-start text-[12px] text-[red]">
                                {simpleValidator.current.message(
                                  "billingSourceData",
                                  billingSourceData,
                                  "required"
                                )}
                              </span>
                            </Col>
                            <Col span={24} className="px-4 mb-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Which language do you like to talk in?{" "}
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Form.Item
                                name="language"
                                required={true}
                                rules={[
                                  {
                                    required: true,
                                    message: "Select a registration type",
                                  },
                                ]}
                                className="mt-4 mb-3 w-[100%]"
                              >
                                <Select
                                  className="h-[40px] text-start"
                                  id="main-input"
                                  value={language}
                                  onChange={(e) => setLanguage(e)}
                                  placeholder="Select Language"
                                  options={
                                    recordsMetaData
                                      ? recordsMetaData.languageOptions
                                      : []
                                  }
                                />
                                <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "language",
                                    language,
                                    "required"
                                  )}
                                </span>
                              </Form.Item>
                            </Col>

                            <Col span={24} className="mt-1 px-4 mb-[60px]">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-center font-semibold"
                              >
                                By completing registration you accept our Terms
                                & Conditions & Privacy Policy
                              </Typography>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col
                          span={13}
                          // onMouseEnter={() => setMouseHover(true)}
                          // onMouseLeave={() => setMouseHover(false)}
                        >
                          <Row
                            className={
                              windowDimensions.height >= 500 &&
                              windowDimensions.height <= 600
                                ? "user-1-invoices-tab-device-main ml-4"
                                : windowDimensions.height >= 600 &&
                                  windowDimensions.height <= 650
                                ? "user-1-invoices-large-tab-device-main ml-4"
                                : windowDimensions.height >= 700 &&
                                  windowDimensions.height <= 800
                                ? "user-1-invoices-main-large-device ml-6"
                                : windowDimensions.height >= 800 &&
                                  windowDimensions.height <= 900
                                ? "user-1-invoices-main-extra-large-device ml-6"
                                : windowDimensions.height >= 900 &&
                                  windowDimensions.height <= 960
                                ? "user-1-invoices-main-extra-extra-large-device ml-6"
                                : windowDimensions.height >= 960 &&
                                  windowDimensions.height <= 1000
                                ? "user-1-invoices-main-extra-extra-large-based-device ml-6"
                                : windowDimensions.height >= 1000
                                ? "user-1-invoices-main-infinite-extra-large-device ml-6"
                                : "user-1-invoices-main ml-4"
                            }
                          >
                            <Col span={24} className="px-4">
                              <h2
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="text-start text-[#292d35] leading-tight mb-4 font-semibold text-[18px]"
                              >
                                Welcome, Let's set up MBook for your business
                              </h2>
                            </Col>
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Your Business Name
                                <span className="text-[red] mx-1">*</span>
                              </Typography>
                              <Form.Item
                                name="businessName"
                                required={true}
                                rules={[
                                  {
                                    required: true,
                                    message: "Enter a business name",
                                  },
                                ]}
                                className="mt-3 mb-3"
                              >
                                <Input
                                  className="p-2 mb-2"
                                  name="businessName"
                                  id="main-input"
                                  value={businessData.businessName}
                                  placeholder="Enter your business name"
                                  onChange={(e) => handleChange(e)}
                                />
                                <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "businessName",
                                    businessData.businessName,
                                    "required"
                                  )}
                                </span>
                              </Form.Item>
                            </Col>
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Mobile No
                                <span className="text-[red] mx-1">*</span>
                              </Typography>
                              <Form.Item
                                name="mobileNo"
                                required={true}
                                className="mt-3 mb-3"
                              >
                                <Input
                                  className="p-2 mb-2"
                                  name="mobileNo"
                                  id="main-input"
                                  maxLength={10}
                                  value={businessData.mobileNo}
                                  placeholder="Enter your mobile no"
                                  onChange={(e) => handleChange(e)}
                                />
                                <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "mobileNo",
                                    businessData.mobileNo,
                                    "required"
                                  )}
                                </span>
                              </Form.Item>
                            </Col>
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Email
                              </Typography>
                              <Form.Item className="mt-3 mb-3">
                                <Input
                                  className="p-2 mb-2"
                                  name="email"
                                  id="main-input"
                                  value={email}
                                  placeholder="Enter your email"
                                  onChange={(e) => validationChange(e)}
                                />
                                <div
                                  id="error-panel"
                                  style={{
                                    display: "none",
                                    // marginTop: "-15px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {isEmpty(email) ? (
                                    ""
                                  ) : (
                                    <p className="text-start text-[#ff0000]">
                                      The email or mobile field is not valid
                                    </p>
                                  )}
                                </div>
                              </Form.Item>
                            </Col>
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Organization Category
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Form.Item className="mt-4 mb-3 w-[100%]">
                                <Select
                                  className="h-[40px] text-start mb-2"
                                  id="main-input"
                                  value={organizationCategory}
                                  onChange={(e) => setOrganizationCategory(e)}
                                  placeholder="Select Organization Category"
                                  //   onChange={validationChange}
                                  options={
                                    recordsMetaData
                                      ? recordsMetaData.categoryOptions
                                      : []
                                  }
                                />
                                <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "organizationCategory",
                                    organizationCategory,
                                    "required"
                                  )}
                                </span>
                              </Form.Item>
                            </Col>

                            <Col span={24} className="px-4 mb-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Is your business GST registered?
                              </Typography>

                              <Radio.Group
                                className="flex"
                                onChange={(e) => setIsGst(e.target.value)}
                                value={isGst}
                              >
                                <div className="gst-register-card">
                                  <Typography>Yes</Typography>
                                  <Radio value={"true"}></Radio>
                                </div>
                                <div className="gst-register-card">
                                  <Typography>No</Typography>
                                  <Radio value={"false"}></Radio>
                                </div>
                              </Radio.Group>
                            </Col>
                            {isGst === "yes" ? (
                              <>
                                <Col span={24} className="px-4">
                                  <Typography
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="text-start font-medium"
                                  >
                                    GST Type
                                  </Typography>

                                  <Form.Item className="mt-4 mb-3 w-[100%]">
                                    <Select
                                      className="h-[40px] text-start mb-2"
                                      id="main-input"
                                      value={gstType}
                                      onChange={(e) => setGstType(e)}
                                      placeholder="Select GST Type"
                                      //   onChange={validationChange}
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.gstTypeOptions
                                          : []
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={24} className="px-4">
                                  <Typography
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="text-start font-medium"
                                  >
                                    GSTIN No (Optional)
                                  </Typography>
                                  <Form.Item name="email" className="mt-3 mb-3">
                                    <Input
                                      className="p-2"
                                      id="main-input"
                                      name="gstIn"
                                      value={businessData.gstIn}
                                      placeholder="Enter your GSTIN no"
                                      onChange={(e) => handleChange(e)}
                                      //   onChange={validationChange}
                                    />
                                  </Form.Item>
                                </Col>
                              </>
                            ) : (
                              ""
                            )}
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Country
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Form.Item className="mt-4 mb-3 w-[100%]">
                                <Select
                                  className="h-[40px] text-start mb-2"
                                  id="main-input"
                                  value={country}
                                  onChange={(e) => setCountry(e)}
                                  placeholder="Select Country"
                                  options={
                                    recordsMetaData
                                      ? recordsMetaData.countryOptions
                                      : []
                                  }
                                />
                                <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "country",
                                    country,
                                    "required"
                                  )}
                                </span>
                              </Form.Item>
                            </Col>
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                State
                                <span className="text-[red] mx-1">*</span>
                              </Typography>

                              <Form.Item className="mt-4 mb-3 w-[100%]">
                                <Select
                                  className="h-[40px] text-start mb-2"
                                  id="main-input"
                                  value={stateDetails}
                                  onChange={(e) => setStateDetails(e)}
                                  placeholder="Select State"
                                  options={
                                    recordsMetaData
                                      ? recordsMetaData.stateOptions
                                      : []
                                  }
                                />
                                <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "stateDetails",
                                    stateDetails,
                                    "required"
                                  )}
                                </span>
                              </Form.Item>
                            </Col>
                            <Col span={24} className="px-4">
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                }}
                                className="text-start font-medium"
                              >
                                Address
                                {/* <span className="text-[red] mx-1">*</span> */}
                              </Typography>
                              <Form.Item className="mt-3 mb-3">
                                <Input.TextArea
                                  className="p-2 mb-2"
                                  name="address"
                                  id="main-input"
                                  value={businessData.address}
                                  placeholder="Enter your address"
                                  onChange={(e) => handleChange(e)}
                                />
                                {/* <span className="mt-[5px] text-start text-[12px] text-[red]">
                                  {simpleValidator.current.message(
                                    "address",
                                    businessData.address,
                                    "required"
                                  )}
                                </span> */}
                              </Form.Item>
                            </Col>
                            <Col span={24} className="mt-2 px-4 mb-[60px]">
                              <div className="w-[100%]">
                                <Typography
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="text-center font-semibold"
                                >
                                  <WhatsAppOutlined className="text-[green]" />{" "}
                                  Receive account updates and reminders on
                                  WhatsApp
                                </Typography>
                              </div>
                              <div className="w-[100%] text-center mt-3 ">
                                <Typography
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="instructions font-semibold"
                                >
                                  <SafetyCertificateOutlined className="text-[#4096ff] mx-1" />{" "}
                                  100% secure
                                </Typography>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Form>
                </Col>
              </Row>
            </Content>
            <Footer className="user-footer">
              <Row justify={"center"}>
                <Col span={16}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Button: {
                          colorPrimary: `linear-gradient(116deg,  ${colors1.join(
                            ", "
                          )})`,
                          colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(
                            colors1
                          ).join(", ")})`,
                          colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(
                            colors1
                          ).join(", ")})`,
                          lineWidth: 0,
                        },
                      },
                    }}
                  >
                    <Button
                      className="p-5 w-[50%]"
                      type="primary"
                      htmlType="submit"
                      // href={businessSectionThird === true ? "/dashboard" : "#"}
                      onClick={() => onFinish()}
                    >
                      {registerLoading ? "Loading..." : "Continue"}
                    </Button>
                  </ConfigProvider>
                </Col>
              </Row>
            </Footer>
          </Layout>
        </div>
      </div>
    </React.Fragment>
  );
};

UserDetails.propTypes = {
  onSignin: PropTypes.any,
  children: PropTypes.object,
  location: PropTypes.object,
};

export default UserDetails;
